import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import { useIntl } from 'react-intl';
import { useMessage, useMessages } from 'modules/intl';
import { AutoAcceptComponent } from './AutoAcceptComponent';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(0, 2),
    marginRight: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    minWidth: '47%',
    justifyContent: 'center'
  },
  acceptContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(1)
  },
  percentage: {
    color: theme.palette.text.primary,
    ...theme.typography.h6
  },
  grid: {
    display: 'flex',
    flexDirection: 'row'
  },
  span: {
    alignSelf: 'center',
    margin: theme.spacing(0, 2),
    color: theme.palette.text.secondary,
    fontSize: theme.spacing(1.8)
  }
}));

const labels = ['insights.autoAccept.SYSTEM', 'insights.autoAccept.USER'];
export const AutoAcceptNoData: React.FC = () => {
  const classes = useStyles();
  const { formatMessage } = useIntl();
  const messages = useMessages(labels);
  const naMessage = useMessage('insights.timeSheetLabels.na');

  return (
    <>
      <Paper
        className={classes.container}
        elevation={3}
        data-testid={'auto-accept-noData-container'}
      >
        <Grid flexWrap={'wrap'} className={classes.grid}>
          <AutoAcceptComponent
            label={messages['insights.autoAccept.SYSTEM']}
            element={
              <Typography
                variant="h4"
                className={classes.percentage}
                data-testid="auto-accept-percentage-message"
              >
                {naMessage}
              </Typography>
            }
          />
          <Typography
            variant="caption"
            whiteSpace="nowrap"
            className={classes.span}
            data-testid="auto-accept-na-values"
          >
            {formatMessage({ id: 'insights.autoAccept.vs' })}
          </Typography>
          <AutoAcceptComponent
            label={messages['insights.autoAccept.USER']}
            element={
              <Typography
                variant="h4"
                className={classes.percentage}
                data-testid="auto-accept-percentage-message"
              >
                {naMessage}
              </Typography>
            }
          />
        </Grid>
      </Paper>
    </>
  );
};
